module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "stand"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("注册用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm._f("numberSlice")(_vm.requestData.userCount)) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("企业数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.companyCount) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("企业用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.companyNumByUser) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("上线软件个数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.productCount) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("日活用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number active",
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.userCountByDay) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("月活用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.userCountByMonth) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("季活用户数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm.requestData.userCountByQuarter) + "\n          ")])]), _vm._v(" "), _c('el-col', {
    staticClass: "elcol",
    attrs: {
      "span": 3
    }
  }, [_c('div', {
    staticClass: "key"
  }, [_c('div', [_vm._v("用户总积分数")])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n            " + _vm._s(_vm._f("numberSlice")(_vm.requestData.userPointCount)) + "\n          ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "charts"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.pointByHour
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading4),
      expression: "loading4"
    }],
    attrs: {
      "id": "charts-box",
      "element-loading-text": "加载中"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.dayVisit
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading5),
      expression: "loading5"
    }],
    attrs: {
      "id": "charts-box-two",
      "element-loading-text": "加载中"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "year",
      "value-format": "yyyy",
      "placeholder": "请选择",
      "picker-options": _vm.yearPickerOptions
    },
    on: {
      "change": _vm.MonthVisit
    },
    model: {
      value: (_vm.visitByMonth_Year),
      callback: function($$v) {
        _vm.visitByMonth_Year = $$v
      },
      expression: "visitByMonth_Year"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading6),
      expression: "loading6"
    }],
    attrs: {
      "id": "charts-box-Three",
      "element-loading-text": "加载中"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "element-select"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "year",
      "value-format": "yyyy",
      "placeholder": "请选择",
      "picker-options": _vm.yearPickerOptions
    },
    on: {
      "change": _vm.QuarterVisit
    },
    model: {
      value: (_vm.visitByQuarter_Year),
      callback: function($$v) {
        _vm.visitByQuarter_Year = $$v
      },
      expression: "visitByQuarter_Year"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading7),
      expression: "loading7"
    }],
    attrs: {
      "id": "charts-box-Four",
      "element-loading-text": "加载中"
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "charts-copy",
    staticStyle: {
      "height": "510px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-copy"
    }
  }, [_c('LeftCharts')], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    attrs: {
      "id": "charts-box-two-copy"
    }
  }, [_c('RightCharts')], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "charts",
    staticStyle: {
      "height": "400px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Census', {
    attrs: {
      "userGuishuPie": _vm.userGuishuPie
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('CensusBar', {
    attrs: {
      "userGuishuBar": _vm.userGuishuBar
    }
  })], 1)], 1)], 1)]), _vm._v(" "), (_vm.dialogVisible) ? _c('ActiveModal', {
    attrs: {
      "dialogVisible": _vm.dialogVisible
    },
    on: {
      "update:dialogVisible": function($event) {
        _vm.dialogVisible = $event
      },
      "update:dialog-visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f753404a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/Management.vue
// module id = 1828
// module chunks = 9